import { useState, useEffect } from "react";
import { Formik, Form, FieldArray, ErrorMessage } from "formik";
import { toast } from "react-toastify";
import { FormField } from "../../../../Components/FormField";
import SidebarField from "../../../../Components/SidebarField";
import TextInput from "../../../../Components/TextInput";
import Button from "../../../../Components/Button";

import AuthApi from "../../../../App/api/auth.apis";
import { useFetchAll } from "../../../../custom/FetchApiHook";
import { IoIosAddCircleOutline, IoMdRemoveCircleOutline } from "react-icons/io";
import { MasterApi } from "../../../../App/api/setting";
import { DeliveryTypeValidation } from "./ValidationSchema";

function AddDeliveryType({ currentItems, getAllData, open, handleClose }) {
  const initialValues = {
    name: currentItems?.name || "",
    factor: currentItems?.factor || [{ name: "", value: "" }],
  };

  const handleSubmit = async (values, { resetForm }) => {
    const payload = {
      name: values.name,
      factor: values.factor,
    };

    try {
      // console.log("values", payload);
      const res = currentItems?._id
        ? MasterApi.master.updateDeliveryType(currentItems?._id, payload)
        : await MasterApi.master.createDeliveryType(payload);
      // console.log("response", res);
    } catch (err) {
      console.error(err);
      toast.error(err?.message);
    } finally {
      resetForm();
      handleClose();
    }
  };

  useEffect(() => {
    // Logic to fetch available components or any other necessary data
  }, []);

  if (open) {
    return (
      <div>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize={true}
          validationSchema={DeliveryTypeValidation}
        >
          {({ handleChange, values, setFieldValue }) => (
            <Form className="w-full gap-4 flex flex-col bg-transparent py-5 px-3">
              <SidebarField
                handleClose={handleClose}
                title={
                  currentItems?._id
                    ? "Update Delivery Type"
                    : "Add New Delivery Type"
                }
                button1={
                  <Button text="Cancel" type="button" onClick={handleClose} />
                }
                button2={
                  <Button
                    text={currentItems?._id ? "Update" : "Submit"}
                    type="submit"
                  />
                }
              >
                <FormField
                  label="Delivery type"
                  tooltip="Enter name of delivery type eg. fixed, distance based"
                >
                  <TextInput
                    name="name"
                    type="text"
                    placeholder="Delivery Fee"
                    value={values.name}
                    onChange={handleChange}
                    required={true}
                  />
                  <ErrorMessage name="name" component="p" className="error" />
                </FormField>

                <FieldArray
                  name="factor"
                  render={(arrayHelpers) => (
                    <div>
                      <FormField
                        className="text-bold mb-2 text-base"
                        tooltip="Enter Delivery Factors"
                        label="Delivery Factor"
                      ></FormField>

                      {values.factor.map((factor, index) => (
                        <div
                          key={index}
                          className="shadow bg-gray-100 p-4 mt-4 rounded-lg"
                        >
                          <div className="flex justify-end items-center">
                            {/* <p className="font-semibold">Factor {index + 1}</p> */}
                            <IoMdRemoveCircleOutline
                              className={`text-xl ${
                                index === 0
                                  ? "text-gray-400 cursor-not-allowed"
                                  : "text-red-500 cursor-pointer"
                              }`}
                              onClick={() => {
                                if (index !== 0) {
                                  arrayHelpers.remove(index);
                                }
                              }}
                              title={
                                index === 0
                                  ? "Cannot remove the first factor"
                                  : "Remove"
                              }
                            />
                          </div>
                          <FormField
                            label="Factor Name"
                            tooltip="Enter delivery factor name eg. distance,weight"
                          >
                            <TextInput
                              name={`factor.${index}.name`}
                              type="text"
                              placeholder="Factor Name"
                              value={factor.name}
                              onChange={handleChange}
                              required={true}
                            />
                            <ErrorMessage
                              name={`factor.${index}.name`}
                              component="p"
                              className="error"
                            />
                          </FormField>
                          <FormField
                            label="Factor Value"
                            tooltip="Enter delivery factor value eg. 1,26"
                          >
                            <TextInput
                              name={`factor.${index}.value`}
                              type="number"
                              placeholder="Factor Value"
                              value={factor.value}
                              onChange={handleChange}
                              required={true}
                            />
                            <ErrorMessage
                              name={`factor.${index}.value`}
                              component="p"
                              className="error"
                            />
                          </FormField>
                        </div>
                      ))}

                      <div className="flex justify-end mt-4">
                        <IoIosAddCircleOutline
                          className={`text-2xl ${
                            values.factor.some(
                              (factor) => !factor.name || !factor.value
                            )
                              ? "text-gray-400 cursor-not-allowed"
                              : "text-green-500 cursor-pointer"
                          }`}
                          onClick={() => {
                            if (
                              values.factor.some(
                                (factor) => !factor.name || !factor.value
                              )
                            ) {
                              toast.error(
                                "All factor fields must be filled out before adding a new factor."
                              );
                            } else {
                              arrayHelpers.push({ name: "", value: "" });
                            }
                          }}
                        />
                      </div>
                    </div>
                  )}
                />
              </SidebarField>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
  return null;
}

export default AddDeliveryType;
